export default __webpack_public_path__ + "static/media/mail.cecf564d.svg";